/* eslint-disable max-len */
import React from 'react'
import SvgIcon from './SvgIcon'

export default props => {
  return (
    <SvgIcon {...props}>
      <path d="M16.3,22c-0.4,0-0.7-0.1-1-0.4L6.7,13c-0.6-0.6-0.6-1.5,0-2l8.6-8.6c0.6-0.6,1.5-0.6,2,0c0.6,0.6,0.6,1.5,0,2L9.7,12 l7.6,7.6c0.6,0.6,0.6,1.5,0,2C17,21.9,16.7,22,16.3,22z" />
    </SvgIcon>
  )
}
